/* BAHARÍ AQUA | Pines v3.2 - Selección progresiva de sandalias y posiciones / Ajax Cart API */
(function () {
  'use strict';
  var sandalProductCache = new Map();
  var CART_FETCH_OPTIONS = { credentials: 'same-origin', headers: { Accept: 'application/json' } };

  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', Object.assign({ cache: 'no-store' }, CART_FETCH_OPTIONS)).then(function (res) {
      if (!res.ok) throw new Error('No se pudo obtener el carrito.');
      return res.json();
    });
  }
  function normalize(str) {
    return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }
  function hasWord(text, words) { return words.test(normalize(text)); }
  function excluded(item) {
    var text = [item.product_type,item.product_title,item.handle].join(' ');
    return hasWord(text, /(?:^|[^a-z])(pins?|pines|charm|adorno|accesorio|jibbitz|llavero|bolso|gorra|camiseta|toalla|botella)(?:$|[^a-z])/);
  }
  // Reconocer productos de calzado cuyo título es el nombre del modelo:
  // p. ej. HAVAIANAS BRASIL PREP CX FECHADA (Color: Blanco, Talla: 35/36).
  // No confundir accesorios Havaianas con sandalias: exigimos tallaje de calzado.
  function hasFootwearSize(item) {
    var variant = normalize([item.variant_title, item.variant_options && item.variant_options.join(' ')].join(' '));
    return /(?:^|[^0-9])(?:1[7-9]|[2-4][0-9]|5[0-2])\s*(?:[\/\-]\s*(?:1[7-9]|[2-4][0-9]|5[0-2]))?(?:$|[^0-9])/.test(variant);
  }
  function footwearBrand(item, product) {
    var nameAndBrand = [item.product_title, item.vendor, product && product.vendor, product && product.title].join(' ');
    return hasWord(nameAndBrand, /\b(?:havaianas|long\s*fu)\b/);
  }
  function candidate(item) {
    if (!item || item.requires_shipping === false || excluded(item)) return false;
    if (hasWord([item.product_type, item.product_title, item.handle].join(' '), /(?:sandalia|chancla|flip.?flop|calzado|slide|ojota|alpargata)/)) return true;
    return footwearBrand(item) && hasFootwearSize(item);
  }
  function getProductInfo(handle) {
    if (!handle) return Promise.resolve(null);
    if (!sandalProductCache.has(handle)) {
      sandalProductCache.set(handle, fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', CART_FETCH_OPTIONS)
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; }));
    }
    return sandalProductCache.get(handle);
  }
  function sandalItems(cart) {
    return Promise.all((cart.items || []).map(function (item) {
      // Cart.js doesn't include tags. Check product tags where available, and
      // fall back to the product type/title/handle of obvious sandals.
      if (!item || excluded(item)) return Promise.resolve(null);
      if (candidate(item)) return Promise.resolve(item);
      return getProductInfo(item.handle).then(function (product) {
        var tags = product && product.tags;
        if (typeof tags === 'string') tags = tags.split(',');
        var normalizedTags = (Array.isArray(tags) ? tags : []).map(normalize);
        if (normalizedTags.includes('bahari-no-sandalia')) return null;
        if (normalizedTags.includes('bahari-sandalia')) return item;
        // Respaldo: tipo del producto o marca registrada y talla de calzado.
        if (hasWord(product && product.type, /(sandalia|chancla|flip.?flop|calzado)/)) return item;
        return footwearBrand(item, product) && hasFootwearSize(item) ? item : null;
      });
    })).then(function (items) { return items.filter(Boolean); });
  }
  window.BahariPinCart = { getCart: fetchCart, getSandals: sandalItems };

  // v3: cada punto del diseño se guarda como una línea independiente.
  function labelFor(n) { return 'Sandalia ' + (n <= 4 ? 'izquierda' : 'derecha') + ' · Posición ' + n; }
  function pinPosition(item) {
    var props = item.properties || {};
    var direct = Number(props['_Bahari posicion']);
    if (Number.isInteger(direct) && direct >= 1 && direct <= 8) return direct;
    var match = String(props['Ubicación del pin'] || '').match(/Posición\s*([1-8])/i);
    return match ? Number(match[1]) : 0;
  }
  function unitOf(item) { return Number((item.properties || {})['_Bahari numero de par']) || 1; }
  function isInstalled(item) { return (item.properties || {})['Modalidad del pin'] === 'Instalado en sandalias'; }
  function isMatchingPair(item, key, unit) {
    var props = item.properties || {};
    return isInstalled(item) && String(props['_Bahari sandalia key']) === String(key) && unitOf(item) === Number(unit);
  }
  function occupiedPositions(cart, key, unit, excludingKey) {
    var used = new Map();
    (cart.items || []).forEach(function (item) {
      if (item.key === excludingKey || !isMatchingPair(item,key,unit)) return;
      var number = pinPosition(item);
      if (number) used.set(number, item.product_title || item.title || 'Pin');
    });
    return used;
  }
  window.BahariPinCart.pinPosition = pinPosition;
  window.BahariPinCart.occupiedPositions = occupiedPositions;

  function setup(root) {
    if (root.dataset.pinReady === 'true') return;
    var form = root.closest('form');
    if (!form) return;
    root.dataset.pinReady = 'true';
    var radios = Array.from(root.querySelectorAll('[data-pin-mode]'));
    var installed = root.querySelector('[data-pin-installed]');
    var positionStep = root.querySelector('[data-pin-position-step]');
    var autoNote = root.querySelector('[data-pin-auto-note]');
    var markers = Array.from(root.querySelectorAll('[data-pin-position]'));
    var chips = Array.from(root.querySelectorAll('[data-pin-position-chip]'));
    var selectedText = root.querySelector('[data-pin-selected]');
    var quantityNote = root.querySelector('[data-pin-quantity-note] strong');
    var occupiedNote = root.querySelector('[data-pin-occupied-note]');
    var pairList = root.querySelector('[data-pin-pairs]');
    var pairLabel = root.querySelector('[data-pin-pair-label]');
    var pairKey = root.querySelector('[data-pin-pair-key]');
    var pairVariant = root.querySelector('[data-pin-pair-variant]');
    var pairUnit = root.querySelector('[data-pin-pair-unit]');
    var unitWrap = root.querySelector('[data-pin-unit-wrap]');
    var unitSelect = root.querySelector('[data-pin-unit-select]');
    var refreshButton = root.querySelector('[data-pin-refresh]');
    var errorBox = root.querySelector('[data-pin-error]');
    var selected = new Set();
    var pairItem = null, lastCart = null, processing = false, requestNumber = 0, loading = false;
    var submitButton = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var qty = form.querySelector('[name="quantity"]') || (form.id && document.querySelector('[name="quantity"][form="'+form.id+'"]'));
    var originalQty = qty ? qty.value : '1';

    function mode() { var radio = radios.find(function (r) {return r.checked;}); return radio ? radio.value : ''; }
    function showError(msg) { errorBox.textContent = msg; errorBox.hidden = false; }
    function clearError() { errorBox.textContent = ''; errorBox.hidden = true; }
    function pairToken() { return pairKey.value + '#' + pairUnit.value; }
    function availablePositions() {
      return lastCart && pairKey.value ? occupiedPositions(lastCart, pairKey.value, pairUnit.value) : new Map();
    }
    function renderPositions() {
      // La imagen y las posiciones solo se muestran después de elegir un par.
      positionStep.hidden = !(mode() === 'Instalado en sandalias' && pairItem && pairKey.value);
      var occupied = availablePositions();
      Array.from(selected).forEach(function(n) {if (occupied.has(n)) selected.delete(n);});
      markers.concat(chips).forEach(function(el) {
        var n = Number(el.dataset.pinPosition || el.dataset.pinPositionChip);
        var taken = occupied.has(n);
        el.disabled = taken;
        el.setAttribute('aria-pressed',String(selected.has(n)));
        el.setAttribute('aria-label',(n <= 4 ? 'Sandalia izquierda' : 'Sandalia derecha')+', posición '+n+(taken ? ', ocupada por '+occupied.get(n) : ', disponible'));
        el.title = taken ? ('Ocupada por '+occupied.get(n)) : labelFor(n);
        el.classList.toggle('is-taken',taken);
      });
      occupiedNote.hidden = occupied.size === 0;
      var ordered = Array.from(selected).sort(function(a,b){return a-b;});
      selectedText.textContent = ordered.length ? ordered.map(labelFor).join(' · ') : 'Selecciona al menos una posición.';
      quantityNote.textContent = String(ordered.length);
      if (qty && mode() === 'Instalado en sandalias') qty.value = String(ordered.length || 1);
    }
    function selectPosition(n) {
      if (mode() !== 'Instalado en sandalias' || !pairKey.value) { showError('Primero selecciona las sandalias de tu carrito.'); return; }
      if (availablePositions().has(n)) {showError('Esa posición está ocupada por otro pin de ese par.'); return;}
      if (selected.has(n)) selected.delete(n); else selected.add(n);
      renderPositions(); clearError();
    }
    markers.concat(chips).forEach(function(btn){
      btn.addEventListener('click',function(){selectPosition(Number(btn.dataset.pinPosition || btn.dataset.pinPositionChip));});
    });
    function clearPair() {
      pairItem = null; pairKey.value = pairLabel.value = pairVariant.value = pairUnit.value = '';
      unitSelect.replaceChildren(); unitWrap.hidden = true; autoNote.hidden = true;
      selected.clear(); renderPositions();
    }
    function updateUnit(value) {
      if (!pairItem) return;
      var n = Math.max(1,Math.min(Number(value)||1,Number(pairItem.quantity)||1));
      pairKey.value = pairItem.key;
      pairVariant.value = String(pairItem.variant_id);
      pairUnit.value = String(n);
      pairLabel.value = pairItem.product_title + (pairItem.variant_title && pairItem.variant_title !== 'Default Title' ? ' · '+pairItem.variant_title : '') + (pairItem.quantity > 1 ? ' · Par '+n+' de '+pairItem.quantity : '');
      selected.clear(); renderPositions(); clearError();
    }
    function choosePair(item, unit) {
      pairItem = item;
      pairList.querySelectorAll('[data-pin-pair-option]').forEach(function(btn){
        var active = btn.dataset.pinPairOption === item.key;
        btn.classList.toggle('is-selected',active); btn.setAttribute('aria-checked',String(active));
      });
      unitSelect.replaceChildren();
      for (var i=1;i<=Math.min(100,Number(item.quantity)||1);i++) {
        var op=document.createElement('option'); op.value=String(i);op.textContent='Par '+i+' de '+item.quantity;unitSelect.appendChild(op);
      }
      unitSelect.value=String(unit||1);unitWrap.hidden=Number(item.quantity)<2;
      updateUnit(unitSelect.value);
    }
    function message(title,body,link) {
      var wrap=document.createElement('div');wrap.className='bahari-pin__cart-message';
      var h=document.createElement('strong');h.textContent=title;wrap.appendChild(h);
      var p=document.createElement('p');p.textContent=body;wrap.appendChild(p);
      if (link) {var a=document.createElement('a');a.href=root.dataset.shopUrl||'/collections/all';a.textContent='Ver sandalias disponibles →';wrap.appendChild(a);}
      pairList.replaceChildren(wrap);
    }
    function renderPairs(items,cart) {
      var savedKey=pairKey.value,savedUnit=pairUnit.value;
      lastCart=cart;pairList.replaceChildren();autoNote.hidden=true;
      if (!items.length) {
        clearPair();message(cart.items.length?'No identificamos sandalias compatibles en el carrito':'Aún no tienes sandalias en el carrito','Agrega primero las sandalias que deseas personalizar. Vuelve luego y pulsa Actualizar.',true);return;
      }
      items.forEach(function(item){
        var b=document.createElement('button');b.type='button';b.className='bahari-pin__pair';b.setAttribute('role','radio');b.setAttribute('aria-checked','false');b.dataset.pinPairOption=item.key;
        var image=document.createElement('img');image.className='bahari-pin__pair-image';image.src=item.image||(item.featured_image&&item.featured_image.url)||'';image.alt='';image.loading='lazy';image.width=62;image.height=62;if(image.getAttribute('src'))b.appendChild(image);
        var body=document.createElement('span');body.className='bahari-pin__pair-details';
        var title=document.createElement('strong');title.textContent=item.product_title||item.title;body.appendChild(title);
        var detail=document.createElement('small');detail.textContent=(item.variant_title && item.variant_title !== 'Default Title'?item.variant_title+' · ':'')+item.quantity+(item.quantity===1?' par':' pares');body.appendChild(detail);b.appendChild(body);
        var tick=document.createElement('span');tick.className='bahari-pin__pair-tick';tick.textContent='✓';tick.setAttribute('aria-hidden','true');b.appendChild(tick);
        b.addEventListener('click',function(){choosePair(item,1);});pairList.appendChild(b);
      });
      var still=items.find(function(item){return item.key===savedKey;});
      if(still) choosePair(still,savedUnit);
      else if(savedKey){clearPair();showError('Las sandalias elegidas cambiaron. Selecciona el par otra vez.');}
      else if(items.length === 1 && Number(items[0].quantity) === 1){
        // Sin ambigüedad: un solo par en el carrito. Se elige automáticamente.
        choosePair(items[0],1);
        autoNote.hidden=false;
      }
    }
    function loadPairs() {
      if(loading)return Promise.resolve();loading=true;refreshButton.disabled=true;
      var ticket=++requestNumber;
      if(!lastCart)message('Consultando tu carrito…','Identificando tus sandalias.',false);
      return fetchCart().then(function(cart){return sandalItems(cart).then(function(items){if(ticket===requestNumber&&mode()==='Instalado en sandalias')renderPairs(items,cart);});})
       .catch(function(){if(mode()==='Instalado en sandalias'){clearPair();message('No pudimos consultar tu carrito','Revisa la conexión y pulsa Actualizar.',false);}})
       .finally(function(){loading=false;refreshButton.disabled=false;});
    }
    function syncMode() {
      var on=mode()==='Instalado en sandalias';installed.hidden=!on;
      [pairLabel,pairKey,pairVariant,pairUnit].forEach(function(el){el.disabled=!on;});
      if(on) loadPairs();
      else{clearPair();if(qty)qty.value=originalQty;}
      renderPositions();clearError();
    }
    radios.forEach(function(r){r.addEventListener('change',syncMode);});
    refreshButton.addEventListener('click',loadPairs);
    unitSelect.addEventListener('change',function(){updateUnit(unitSelect.value);});

    // Interceptación CAPTURE para ambos formularios de producto (Sense y Baharí).
    // Para instalar, usamos cart/add.js con una línea por posición seleccionada.
    form.addEventListener('submit',function(ev){
      if(mode() !== 'Instalado en sandalias') {
        if(!mode()){ev.preventDefault();ev.stopImmediatePropagation();showError('Elige cómo deseas recibir tu pin.');}
        return;
      }
      ev.preventDefault();ev.stopImmediatePropagation();
      if(processing)return;
      if(!pairKey.value){showError('Selecciona un par de sandalias de tu carrito.');return;}
      if(!selected.size){showError('Selecciona al menos una posición para instalar el pin.');return;}
      var id=Number(new FormData(form).get('id'));
      if(!id){showError('Selecciona una variante disponible del pin.');return;}
      processing=true;
      if(submitButton){submitButton.disabled=true;submitButton.setAttribute('aria-busy','true');}
      fetchCart().then(function(cart){
        var sandal=(cart.items||[]).find(function(item){return item.key===pairKey.value;});
        if(!sandal||String(sandal.variant_id)!==pairVariant.value||Number(sandal.quantity)<Number(pairUnit.value))throw new Error('Las sandalias cambiaron en tu carrito. Pulsa Actualizar y vuelve a seleccionarlas.');
        var occupied=occupiedPositions(cart,pairKey.value,pairUnit.value);
        var requested=Array.from(selected).sort(function(a,b){return a-b;});
        if(requested.some(function(n){return occupied.has(n);}))throw new Error('Una de las posiciones fue ocupada por otro pin. Actualiza las sandalias y las posiciones.');
        var fd=new FormData(form),base={};
        fd.forEach(function(value,key){var match=key.match(/^properties\[(.+)\]$/);if(match&&match[1] !== 'Ubicación del pin' && value!=='')base[match[1]]=String(value);});
        base['Modalidad del pin']='Instalado en sandalias';
        base['Referencia de las sandalias']=pairLabel.value;
        base['_Bahari sandalia key']=pairKey.value;
        base['_Bahari sandalia variante']=pairVariant.value;
        base['_Bahari numero de par']=pairUnit.value;
        var items=requested.map(function(n){return {id:id,quantity:1,properties:Object.assign({},base,{'Ubicación del pin':labelFor(n),'_Bahari posicion':String(n)})};});
        return fetch(rootUrl()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
      }).then(function(res){return res.json().then(function(data){if(!res.ok||data.status)throw new Error(data.description||data.message||'No fue posible agregar los pines al carrito.');return data;});})
      .then(function(){window.location.assign(rootUrl()+'cart');})
      .catch(function(e){showError(e.message||'No fue posible agregar los pines.');root.scrollIntoView({behavior:'smooth',block:'center'});loadPairs();})
      .finally(function(){processing=false;if(submitButton){submitButton.disabled=false;submitButton.removeAttribute('aria-busy');}});
    },true);
    syncMode();
  }
  function initialize(scope) {
    if(!scope)return;
    if(scope.matches&&scope.matches('[data-bahari-pin-selector]'))setup(scope);
    if(scope.querySelectorAll)scope.querySelectorAll('[data-bahari-pin-selector]').forEach(setup);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initialize(document);});else initialize(document);
  document.addEventListener('shopify:section:load',function(event){initialize(event.target);});
  window.addEventListener('pageshow',function(){document.querySelectorAll('[data-bahari-pin-selector][data-pin-ready="true"]').forEach(function(root){var r=root.querySelector('[data-pin-mode]:checked');var b=root.querySelector('[data-pin-refresh]');if(r&&r.value==='Instalado en sandalias'&&b)b.click();});});
})();
